import { Input } from "../../interfaces";
import CheckboxInput from "./CheckboxInput";
import FileInput from "./FileInput";
import MultiRangeSlider from "./multiRangeSlider/MultiRangeSlider";
import SelectInput from "./SelectInput";
import SkillInput from "./SkillInput";
import SwitchInput from "./SwitchInput";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";

const CustomInput = (props: Input) => {
  const inputType = props.type;

  let inputDisplayed = () => {
    if (
      inputType === "text" ||
      inputType === "password" ||
      inputType === "Date" ||
      inputType === "time" ||
      inputType === "number" ||
      inputType === "float"
    ) {
      return <TextInput {...props} />;
    } else if (inputType === "textarea") {
      return <TextAreaInput {...props} />;
    } else if (inputType === "select") {
      return <SelectInput {...props} />;
    } else if (inputType === "file") {
      return <FileInput {...props} />;
    } else if (inputType === "switch") {
      return <SwitchInput {...props} />;
    } else if (inputType === "range") {
      return (
        <div style={{ position: "relative", width: "186px" }}>
          <MultiRangeSlider {...props} />
        </div>
      );
    } else if (inputType === "checkbox") {
      return <CheckboxInput {...props} />;
    } else if (inputType === "skill") {
      return <SkillInput {...props} />;
    }
  };
  return <div>{inputDisplayed()}</div>;
};
export default CustomInput;
